<div class="modal-header">
  <h4 class="modal-title">Panel Display Time</h4>
  <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>

<div class="modal-body">
  <div class="d-flex mb-30px request-desc">
    To Access voiced Display Time.<br>
    Press the buttons with IR Remote as follows.
  </div>
  <div class="d-flex flex-row align-items-center pb-24px">
    <i class="fa-solid fa-forward i-remote"></i>
    <i class="fa-regular fa-plus i-plus"></i>
    <i class="fa-solid fa-play i-remote"></i>
    <i class="fa-regular fa-plus i-plus"></i>
    <i class="fa-duotone fa-pause i-remote"></i>
    <i class="fa-regular fa-plus i-plus"></i>
    <i class="fa-solid fa-backward i-remote"></i>
  </div>

  <div>
    <img class="img-remote" src="../assets/img/remotecontroller.png">
  </div>
</div>


